import { IQuestionModel } from '@care-portals/api-interfaces';

const acneBelugaQuestions: IQuestionModel[] = [
  {
    class: 'ineligible',
    field: 'acneBeluga_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    isLast: true,
    blockQuestionFlow: true,
    extras: { sendToBeluga: false },
    answer: {}
  },
  {
    field: 'acneBeluga_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'acneBeluga_sexAssignedAtBirth',
    extras: { sendToBeluga: false },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_sexAssignedAtBirth_male',
          value: 'Male'
        },
        {
          key: 'acneBeluga_sexAssignedAtBirth_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label:
      'Are you currently pregnant, breastfeeding or planning to become pregnant?',
    field: 'acneBeluga_pregnancy',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_pregnancy_yes',
          value: 'Yes'
        },
        {
          key: 'acneBeluga_pregnancy_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Consent (Pregnancy)',
    educationalSlide: `Read the following for more information about this product and its potential side effects:

I understand that the medication prescribed to me by my healthcare provider may not be safe to take during pregnancy. I acknowledge that taking this medication while pregnant could pose risks to my health and the health of a developing fetus.

I agree to take necessary precautions to avoid becoming pregnant while using this medication, including the use of effective contraception methods.

By selecting below, I confirm that I have read and understand the information provided above. I consent to proceed with the treatment under these conditions.`,
    field: 'acneBeluga_pregnancyConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_pregnancyConsent_disagree',
          class: 'option-decline',
          value: 'I have read the information and do NOT wish to proceed'
        },
        {
          key: 'acneBeluga_pregnancyConsent_agree',
          class: 'option-consent',
          value:
            'I have read and understand the above information, I understand the risks and wish to proceed'
        }
      ]
    }
  },
  {
    label: 'How would you describe the severity of your acne?',
    field: 'acneBeluga_severity',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_severity_mild',
          value: 'Mild'
        },
        {
          key: 'acneBeluga_severity_moderate',
          value: 'Moderate'
        },
        {
          key: 'acneBeluga_severity_severe',
          value: 'Severe'
        }
      ]
    }
  },
  {
    label: 'Where do you primarily experience acne? (Check all that apply)',
    field: 'acneBeluga_location',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'acneBeluga_location_face',
          value: 'Face'
        },
        {
          key: 'acneBeluga_location_chest',
          value: 'Chest'
        },
        {
          key: 'acneBeluga_location_back',
          value: 'Back'
        },
        {
          key: 'acneBeluga_location_shoulders',
          value: 'Shoulders'
        },
        {
          key: 'acneBeluga_location_other',
          value: 'Other'
        }
      ]
    }
  },
  {
    label: 'Please describe the pattern of your outbreaks?',
    field: 'acneBeluga_outbreakPattern',
    type: 'info',
    answer: {
      name: 'acneBeluga_outbreakPattern',
      type: 'text',
      placeholder: 'Describe your acne outbreak pattern'
    }
  },
  {
    label: 'How long have you been experiencing acne?',
    field: 'acneBeluga_duration',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_duration_lessThan6',
          value: 'Less than 6 months'
        },
        {
          key: 'acneBeluga_duration_6to12',
          value: '6-12 months'
        },
        {
          key: 'acneBeluga_duration_1to3',
          value: '1-3 years'
        },
        {
          key: 'acneBeluga_duration_moreThan3',
          value: 'More than 3 years'
        }
      ]
    }
  },
  {
    label:
      'Have you noticed any triggers that worsen your acne? (Check all that apply)',
    field: 'acneBeluga_triggers',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'acneBeluga_triggers_stress',
          value: 'Stress'
        },
        {
          key: 'acneBeluga_triggers_diet',
          value: 'Diet'
        },
        {
          key: 'acneBeluga_triggers_menstrual',
          value: 'Menstrual cycle'
        },
        {
          key: 'acneBeluga_triggers_skincare',
          value: 'Skincare products'
        },
        {
          key: 'acneBeluga_triggers_weather',
          value: 'Weather changes'
        },
        {
          key: 'acneBeluga_triggers_other',
          value: 'Other'
        },
        {
          key: 'acneBeluga_triggers_unknown',
          uncheckOthers: true,
          value: 'I do not know of any triggers'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about your triggers',
    field: 'acneBeluga_triggersDetails',
    type: 'info',
    answer: {
      name: 'acneBeluga_triggersDetails',
      type: 'text',
      placeholder: 'Describe your acne triggers'
    }
  },
  {
    label: 'Have you treated your acne in the past?',
    field: 'acneBeluga_previousTreatment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_previousTreatment_yes',
          value: 'Yes'
        },
        {
          key: 'acneBeluga_previousTreatment_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Have you used any of the following acne treatments before? (Check all that apply)',
    field: 'acneBeluga_previousTreatmentTypes',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'acneBeluga_previousTreatmentTypes_azelaic',
          value: 'Azelaic Acid'
        },
        {
          key: 'acneBeluga_previousTreatmentTypes_kojic',
          value: 'Kojic Acid'
        },
        {
          key: 'acneBeluga_previousTreatmentTypes_spironolactone',
          value: 'Spironolactone'
        },
        {
          key: 'acneBeluga_previousTreatmentTypes_tretinoin',
          value: 'Tretinoin'
        },
        {
          key: 'acneBeluga_previousTreatmentTypes_triamcinolone',
          value: 'Triamcinolone'
        },
        {
          key: 'acneBeluga_previousTreatmentTypes_other',
          value: 'Other topical or oral acne treatments'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about your previous treatment?',
    field: 'acneBeluga_previousTreatmentDetails',
    type: 'info',
    answer: {
      name: 'acneBeluga_previousTreatmentDetails',
      type: 'text',
      placeholder: 'Describe your previous acne treatments'
    }
  },
  {
    label:
      'Can you tell us more about which treatment was effective or ineffective for you?',
    field: 'acneBeluga_treatmentEffectiveness',
    type: 'info',
    answer: {
      name: 'acneBeluga_treatmentEffectiveness',
      type: 'text',
      placeholder: 'Describe treatment effectiveness'
    }
  },
  {
    label:
      'Do you have any history of sensitivity or adverse reactions to acne treatments?',
    field: 'acneBeluga_adverseReactions',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_adverseReactions_yes',
          value: 'Yes'
        },
        {
          key: 'acneBeluga_adverseReactions_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Please tell us more about which medication you had side effects to and tell us about what you experienced?',
    field: 'acneBeluga_adverseReactionsDetails',
    type: 'info',
    answer: {
      name: 'acneBeluga_adverseReactionsDetails',
      type: 'text',
      placeholder: 'Describe your adverse reactions'
    }
  },
  {
    label:
      'Do you experience excessive dryness, peeling, or irritation when using topical treatments?',
    field: 'acneBeluga_skinSensitivity',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_skinSensitivity_yes',
          value: 'Yes'
        },
        {
          key: 'acneBeluga_skinSensitivity_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you have any active skin infections or open wounds in the areas of your outbreak?',
    field: 'acneBeluga_skinInfections',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_skinInfections_yes',
          value: 'Yes'
        },
        {
          key: 'acneBeluga_skinInfections_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you have a history of the following conditions? (Check all that apply)',
    field: 'acneBeluga_medicalHistory',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'acneBeluga_medicalHistory_rosacea',
          value: 'Rosacea'
        },
        {
          key: 'acneBeluga_medicalHistory_eczema',
          value: 'Eczema'
        },
        {
          key: 'acneBeluga_medicalHistory_psoriasis',
          value: 'Psoriasis'
        },
        {
          key: 'acneBeluga_medicalHistory_skinInfections',
          value: 'Skin infections'
        },
        {
          key: 'acneBeluga_medicalHistory_liver',
          value: 'Liver disease'
        },
        {
          key: 'acneBeluga_medicalHistory_kidney',
          value: 'Kidney disease'
        },
        {
          key: 'acneBeluga_medicalHistory_hormonal',
          value: 'Hormonal disorders (e.g., polycystic ovary syndrome)'
        },
        {
          key: 'acneBeluga_medicalHistory_other',
          value: 'Other'
        },
        {
          key: 'acneBeluga_medicalHistory_None',
          uncheckOthers: true,
          value: 'None of the Above'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about this condition',
    field: 'acneBeluga_medicalHistoryDetails',
    type: 'info',
    answer: {
      name: 'acneBeluga_medicalHistoryDetails',
      type: 'text',
      placeholder: 'Describe your medical condition'
    }
  },
  {
    label:
      'Do you have a history of hormonal imbalances or conditions related to hormone levels?',
    field: 'acneBeluga_hormonalImbalance',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_hormonalImbalance_yes',
          value: 'Yes'
        },
        {
          key: 'acneBeluga_hormonalImbalance_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about your hormonal imbalance.',
    field: 'acneBeluga_hormonalImbalanceDetails',
    type: 'info',
    answer: {
      name: 'acneBeluga_hormonalImbalanceDetails',
      type: 'text',
      placeholder: 'Describe your hormonal imbalance'
    }
  },
  {
    label: 'Do you smoke or use any tobacco products?',
    field: 'acneBeluga_tobacco',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_tobacco_yes',
          value: 'Yes'
        },
        {
          key: 'acneBeluga_tobacco_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you consume more than 2 alcoholic beverages a day or more than 14 beverages per week?',
    field: 'acneBeluga_alcohol',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_alcohol_yes',
          value: 'Yes'
        },
        {
          key: 'acneBeluga_alcohol_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label:
      'Do you have any specific concerns or questions about this treatment or would you like to provide more information to the medical team?',
    field: 'acneBeluga_specificConcerns',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_specificConcerns_yes',
          value: 'Yes'
        },
        {
          key: 'acneBeluga_specificConcerns_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about your concerns or questions.',
    field: 'acneBeluga_concernsDetails',
    type: 'info',
    answer: {
      name: 'acneBeluga_concernsDetails',
      type: 'text',
      placeholder: 'Describe your concerns or questions'
    }
  },
  {
    label: 'Consent (Acne Treatment)',
    educationalSlide: `Introduction
You have been diagnosed with acne, a common skin condition characterized by pimples, blackheads, whiteheads, and sometimes cysts or nodules on the face, neck, back, chest, and shoulders. Acne occurs when hair follicles become clogged with oil and dead skin cells. Factors such as hormones, bacteria, and genetics can contribute to its development.

Purpose of Treatment
The goal of your acne treatment is to reduce and manage symptoms, improve the appearance of your skin, prevent scarring, and enhance your overall quality of life. Treatment plans are personalized and may include topical medications, oral medications, lifestyle changes, or procedural therapies, depending on the severity and type of your acne.

Treatment Options
Topical Medications: Applied directly to the skin to reduce inflammation, unclog pores, and decrease bacterial growth. These may include:
   - Retinoids
   - Benzoyl peroxide
   - Antibiotics
   - Salicylic acid
   - Azelaic acid
   - Other including combination creams
Oral Medications: Taken by mouth to address internal factors contributing to acne. These may include:
   - Antibiotics
   - Hormonal therapies (e.g., birth control pills)
   - Isotretinoin (a vitamin A derivative)
   - Other oral medications

Potential Benefits
- Reduction of acne lesions and inflammation
- Improvement in skin texture and appearance
- Prevention of new acne formation
- Decreased risk of scarring
- Enhanced self-esteem and confidence

Potential Risks and Side Effects
While acne treatments are generally safe, possible risks and side effects may include:
Topical Medications:
   - Skin irritation, redness, dryness, or peeling
   - Increased sensitivity to sunlight (photosensitivity)
   - Allergic reactions
Oral Medications:
   - Gastrointestinal upset (nausea, diarrhea)
   - Dizziness or headaches
   - Increased sun sensitivity
   - Changes in menstrual cycle (with hormonal therapies)
   - Mood changes or depression (with isotretinoin)
   - Elevated cholesterol or liver enzymes (with isotretinoin)
   - Birth defects if taken during pregnancy (isotretinoin and spironolactone is strictly contraindicated in pregnancy)
   - Development of antibiotic resistance

Patient Responsibilities
- Medical Disclosure: Inform your healthcare provider of any allergies, existing medical conditions, or medications and supplements you are currently taking.
- Treatment Adherence: Follow the prescribed treatment regimen precisely as directed.
- Appointments: Attend all scheduled follow-up appointments for monitoring and adjustments to your treatment plan.
- Communication: Report any side effects, adverse reactions, or concerns to your healthcare provider promptly.
- Lifestyle Modifications: Adopt recommended lifestyle changes, such as a balanced diet, regular exercise, stress management, and proper skin hygiene.
- Sun Protection: Use sunscreen daily to protect your skin, especially when using treatments that increase sun sensitivity.
- Avoid Skin Picking: Refrain from picking, squeezing, or popping acne lesions to prevent scarring and infection.

Alternative Treatments
- Over-the-Counter Products: Non-prescription creams, cleansers, and spot treatments containing ingredients like benzoyl peroxide or salicylic acid.
- Natural Remedies: Use of herbal or natural products (e.g., tea tree oil), though efficacy may vary.
- No Treatment: Opting to not undergo treatment, understanding that acne may persist or worsen.

Acknowledgment and Consent
By signing below, you acknowledge that:
- You have been informed about your acne condition and the proposed treatment options.
- You understand the potential benefits, risks, and side effects associated with the treatment.
- You agree to inform your healthcare provider of any changes in your health or reactions to the treatment.
- You consent to proceed with the recommended acne treatment plan, understanding that you can withdraw consent or discontinue treatment at any time.`,
    field: 'acneBeluga_treatmentConsent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'acneBeluga_treatmentConsent_disagree',
          class: 'option-decline',
          value:
            'I have read the above information and I do NOT wish to continue'
        },
        {
          key: 'acneBeluga_treatmentConsent_agree',
          class: 'option-consent',
          value:
            'I have read and understand the information and I wish to continue'
        }
      ]
    }
  }
];
export default acneBelugaQuestions;
